import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { UserEditionComponent } from './user-edition.component';
import { UserDetailsResolver } from '../user-details/user-details.resolver';

@NgModule({
    imports: [
      NgbModule,
      SharedModule
    ],
    declarations: [UserEditionComponent],
    exports: [UserEditionComponent],
    providers: [UserDetailsResolver]
  })
  export class UserEditionModule {}
